import classNames from "classnames";
import { Dispatch, SetStateAction } from "react";
import { Color } from "utils/theme";

interface RadioGroupItem {
  value: any;
  label?: string | React.ReactNode;
  disabled?: boolean;
}

interface RadioGroupProps {
  items: Array<RadioGroupItem>;
  selected: any;
  setSelected:
    | ((value: number | string) => void)
    | Dispatch<SetStateAction<any>>;
  className?: string;
  /**
   * Names the group for analytics, so each option is counted separately instead
   * of every radio press in the app collapsing into one key.
   */
  name?: string;
}

export default function RadioGroup({
  items,
  selected,
  setSelected,
  className,
  name,
}: RadioGroupProps) {
  return (
    <div
      className={classNames(
        "h-[4rem] xl:h-[4.5rem] w-full p-1 border rounded-xl flex items-center space-x-1 overflow-auto",
        className
      )}
      style={{
        background: Color.Primary[800],
        borderColor: Color.Primary[700],
      }}
    >
      {items
        .filter((item) => !item.disabled)
        .map((item, index) => {
          const checked = item.value === selected;
          return (
            <button
              key={item.value.toString() + index}
              aria-label="radio-button-option"
              data-analytics={name ? `${name}.${item.value}` : undefined}
              className={
                "rounded-lg cursor-pointer h-full w-full px-3 flex items-center justify-center whitespace-nowrap"
              }
              style={{
                background: checked ? Color.Primary[600] : "none",
                color: checked ? Color.White : Color.Primary[400],
                fill: checked ? Color.White : Color.Primary[400],
              }}
              onClick={() => {
                if (checked) {
                  const nextValue = items[index + 1]?.value || items[0].value;
                  setSelected(nextValue);
                } else {
                  setSelected(item.value);
                }
              }}
              onPointerDown={(e) => {
                e.currentTarget.style.opacity = "0.6";
              }}
              onPointerUp={(e) => {
                e.currentTarget.style.opacity = "1";
              }}
              onPointerLeave={(e) => {
                e.currentTarget.style.opacity = "1";
              }}
            >
              {item.label}
            </button>
          );
        })}
    </div>
  );
}
